<template>
    <div class="vfb-field vfb-field--select" :class="classes.wrapper">
        <div class="vfb-field__container" :class="[classes.container, { 'has-value': hasValue }]">
            <FormLabel :id="id" :label="label" :required="required"
                       :className="classes.label"></FormLabel>

            <select class="vfb-select" :class="[classes.input, { 'has-value': hasValue }]"
                    @input="(event) => handleInput(event)"
                    :name="name"
                    :disabled="disabled" :required="required" :id="id"
                    :aria-describedby="helpText ? id + '-help-block' : undefined"
            >
                <option disabled value="" :selected="!modelValue"></option>

                <option v-for="(option) in options" :key="option.value" :value="option.value" :disabled="!!option.disabled" :selected="!!modelValue && modelValue == option.value">
                    {{ option.label }}
                </option>
            </select>

            <HelpText v-if="helpText" :helpText="helpText" :id="id + '-help-block'" :className="classes.help" />
        </div>

        <FormErrors class="vfb-errors" :class="classes.errors" />
    </div>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import FormLabel from './Label.ce.vue'
import FormErrors from './Errors.ce.vue'
import HelpText from "./includes/HelpText.ce.vue";

const emit = defineEmits<{
    (event: 'update:modelValue', value: string): void
}>()


interface Classes {
    wrapper?: string;
    container?: string;
    input?: string;
    label?: string;
    help?: string;
    errors?: string;
}

interface Props {
    required?: boolean,
    disabled?: boolean,
    label: string,
    modelValue?: string,
    name?: string,
    options?: Array<{ label: string, value: string, disabled?: boolean }>,
    size?: string,
    id: string,
    floatingLabel?: boolean,
    helpText?: string,
    classes?: Classes,
}

const props = withDefaults(defineProps<Props>(), {
    floatingLabel: true,
    size: 'default',
    modelValue: '',
    classes: () => ({
        wrapper: 'form-group js-form-validation__group',
        container: 'position-relative',
        input: 'form-select',
        label: 'form-label',
        help: '',
        errors: '',
    }),
});

const hasValue = computed<boolean>(() =>
    props.modelValue !== null && props.modelValue !== undefined && props.modelValue.length > 0
)

const handleInput = (event: Event) => {
    emit('update:modelValue', (event.target as HTMLInputElement).value);
}

</script>
